"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_router_dom_1 = require("react-router-dom");
var mobx_react_1 = require("mobx-react");
var api_1 = __importStar(require("api"));
var config_1 = __importDefault(require("config"));
var use_stores_1 = require("hooks/use-stores");
var use_notification_1 = require("hooks/use-notification");
var use_dialog_1 = require("hooks/use-dialog");
var Modal_1 = __importDefault(require("components/modal/Modal"));
var Notification_1 = require("components/Notification");
var CreateProductForm_1 = __importDefault(require("./CreateProductForm"));
var product_create_icon_svg_1 = __importDefault(require("res/img/product-create-icon.svg"));
var Dialog_1 = require("../../Dialog");
var UserStore_1 = require("../../../stores/UserStore");
var TableHeading_1 = require("../../common/table/TableHeading");
var CreateProduct = mobx_react_1.observer(function () {
    var _a = react_1.useState({}), data = _a[0], setData = _a[1];
    var _b = react_1.useState([]), files = _b[0], setFiles = _b[1];
    var _c = react_1.useState(false), success = _c[0], setSuccess = _c[1];
    var _d = use_stores_1.useStores(), productsStore = _d.productsStore, productCategoriesStore = _d.productCategoriesStore, productSubCategoriesStore = _d.productSubCategoriesStore, apiStore = _d.apiStore, userStore = _d.userStore, prefsStore = _d.prefsStore;
    var _e = react_1.useState([]), subCategories = _e[0], setSubCategories = _e[1];
    var priceTimeout = react_1.useRef(null);
    var redirectTimeout = react_1.useRef(null);
    var notification = use_notification_1.useNotification();
    var dialog = use_dialog_1.useDialog();
    var history = react_router_dom_1.useHistory();
    var busyRoutes = apiStore.data.busyRoutes;
    var apiRoutes = config_1.default.apiRoutes;
    react_1.useEffect(function () {
        document.title = 'Shop CMS - Create Product';
        if (!productCategoriesStore.data || productCategoriesStore.data.length <= 0) {
            api_1.default.getProductCategories()
                .then(function (response) { return productCategoriesStore.setData(response.data); })
                .catch(api_1.catchHandler);
        }
        if (!productSubCategoriesStore.data || productSubCategoriesStore.data.length <= 0) {
            api_1.default.getProductSubCategories()
                .then(function (response) { return productSubCategoriesStore.setData(response.data); })
                .catch(api_1.catchHandler);
        }
    }, []);
    react_1.useEffect(function () {
        if (data.productCategory) {
            getSubCategories();
        }
    }, [data.productCategory]);
    var getSubCategories = function () {
        var newSubCategories = [];
        for (var _i = 0, _a = productSubCategoriesStore.data; _i < _a.length; _i++) {
            var subCategory = _a[_i];
            if (subCategory.productCategory.id === data.productCategory.id) {
                newSubCategories.push(subCategory);
            }
        }
        setSubCategories(newSubCategories);
    };
    var changeHandler = function (e) {
        var _a;
        var value = e.currentTarget.value;
        var numberEx = /^[+-]?\d+(\.\d+)?$/;
        if (value === '0') {
            value = 0;
        }
        else if (numberEx.test(value)) {
            value = Math.round(value * 100) / 100;
        }
        if (e.currentTarget.name === 'price') {
            clearTimeout(priceTimeout.current);
            priceTimeout.current = setTimeout(function () {
                setData(__assign(__assign({}, data), { price: value.toFixed(2) }));
            }, 1200);
        }
        if (e.currentTarget.name === 'stock') {
            value = value === 0 ? 0 : Math.floor(value);
        }
        setData(__assign(__assign({}, data), (_a = {}, _a[e.currentTarget.name] = value, _a)));
    };
    var categoryChangeHandler = function (productCategory) {
        setData(__assign(__assign({}, data), { productCategory: productCategory }));
    };
    var categorySubmitHandler = function (value) {
        api_1.default.createProductCategory({ name: value })
            .then(function (response) {
            productCategoriesStore.addDataItem(response.data);
            setData(__assign(__assign({}, data), { productCategory: response.data }));
        }).catch(api_1.catchHandler);
    };
    var subCategoryChangeHandler = function (productSubCategory) {
        setData(__assign(__assign({}, data), { productSubCategory: productSubCategory }));
    };
    var subCategorySubmitHandler = function (value) {
        api_1.default.createProductSubCategory({
            name: value,
            productCategoryId: data.productCategory.id
        })
            .then(function (response) {
            productSubCategoriesStore.addDataItem(response.data);
            getSubCategories();
            setData(__assign(__assign({}, data), { productSubCategory: response.data }));
        }).catch(api_1.catchHandler);
    };
    var getImageWidth = function (url) { return new Promise(function (resolve) {
        var img = new Image();
        img.onload = function () { return resolve(img.width); };
        img.src = url;
    }); };
    var imageChangeHandler = function (e) { return __awaiter(void 0, void 0, void 0, function () {
        var inputFiles, newFiles, warnings, i, file, url, imgWidth;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    inputFiles = e.currentTarget.files;
                    newFiles = [];
                    warnings = [];
                    i = 0;
                    _a.label = 1;
                case 1:
                    if (!(i < inputFiles.length)) return [3 /*break*/, 4];
                    file = inputFiles[i];
                    url = URL.createObjectURL(file);
                    return [4 /*yield*/, getImageWidth(url)];
                case 2:
                    imgWidth = _a.sent();
                    if (imgWidth < 1000)
                        warnings.push(file.name);
                    newFiles.push(file);
                    URL.revokeObjectURL(url);
                    _a.label = 3;
                case 3:
                    i++;
                    return [3 /*break*/, 1];
                case 4:
                    if (warnings.length > 0) {
                        dialog({
                            variant: Dialog_1.DialogVariants.CONFIRMATION,
                            title: 'Image(s) not optimal',
                            description: "The following image(s): " + warnings.join(",") + " are below 1000px wide. These images will not display well on larger screens or retina displays. Would you like to continue with this upload?"
                        }).then(function () {
                            setFiles(files.concat(newFiles));
                        });
                        return [2 /*return*/];
                    }
                    setFiles(files.concat(newFiles));
                    return [2 /*return*/];
            }
        });
    }); };
    var imageDeleteHandler = function (index) {
        setFiles(files.filter(function (file, i) { return index !== i; }));
    };
    var submitHandler = function (e) {
        e.preventDefault();
        var product = new FormData();
        var error = null;
        if (files.length <= 0)
            error = 'Please upload a product image';
        if (userStore.data.databaseConnection !== UserStore_1.CODA) {
            if (typeof data.price === 'undefined')
                error = 'Please enter a price';
            if (typeof data.stock === 'undefined')
                error = 'Please enter an initial stock level';
        }
        if (!data.productCategory || !data.productCategory.id)
            error = 'Please choose a product category';
        if (!data.name || data.name.length <= 0)
            error = 'Please enter a product name';
        if (error !== null) {
            notification({
                variant: Notification_1.NotificationVariants.ERROR,
                message: error
            });
            return;
        }
        for (var k in data) {
            if (data.hasOwnProperty(k)) {
                if (k === 'productCategory') {
                    product.append('productCategoryId', data[k].id.toString());
                    continue;
                }
                if (k === 'productSubCategory') {
                    product.append('productSubCategoryId', data[k].id.toString());
                    continue;
                }
                product.append(k, data[k]);
            }
        }
        for (var _i = 0, files_1 = files; _i < files_1.length; _i++) {
            var file = files_1[_i];
            product.append('images[]', file);
        }
        api_1.default.createProduct(product)
            .then(function (response) {
            productsStore.addDataItem(response.data);
            notification({
                variant: Notification_1.NotificationVariants.SUCCESS,
                message: 'Product successfully created'
            });
            redirectHandler(response.data.id);
        })
            .catch(api_1.catchHandler);
    };
    var redirectHandler = function (productId) {
        setSuccess(true);
        clearTimeout(redirectTimeout.current);
        redirectTimeout.current = setTimeout(function () {
            history.replace("/products/edit/" + productId);
        }, 1000);
    };
    return (react_1.default.createElement(Modal_1.default, { title: [
            react_1.default.createElement("img", { key: "cp_title_1", src: product_create_icon_svg_1.default, alt: 'product' }),
            react_1.default.createElement("span", { key: "cp_title_2" }, "Create a Product")
        ] },
        react_1.default.createElement("div", { className: 'create-product create-modal' },
            react_1.default.createElement(CreateProductForm_1.default, { busy: busyRoutes.includes(apiRoutes.PRODUCTS + ("?page=" + prefsStore.data.productsTable.page + "&limit=" + prefsStore.data.productsTable.perPage + "&sort=" + ((prefsStore.data.productsTable.sort.direction === TableHeading_1.TableDirections.DOWN ? '-' : '') + (prefsStore.data.productsTable.sort.name !== null ? prefsStore.data.productsTable.sort.name : 'id')) + "&search=" + prefsStore.data.productsTable.search)), categoriesBusy: busyRoutes.includes(apiRoutes.PRODUCT_CATEGORIES), data: data, categories: productCategoriesStore.data, subCategories: subCategories, onChange: changeHandler, onCategoryChange: categoryChangeHandler, onSubmitCategory: categorySubmitHandler, onSubCategoryChange: subCategoryChangeHandler, onSubCategorySubmit: subCategorySubmitHandler, images: files, onChangeImages: imageChangeHandler, onDeleteImage: imageDeleteHandler, onSubmit: submitHandler, success: success }))));
});
exports.default = CreateProduct;
